var map = {
	"./AdGuardDnsInfo.vue": [
		"f258",
		"chunk-72a94eb0"
	],
	"./AdGuardFilterStatus.vue": [
		"6750",
		"chunk-ceaa5fd0"
	],
	"./AdGuardStats.vue": [
		"4aa6",
		"chunk-50f31ec3",
		"chunk-daa165fc"
	],
	"./AdGuardTopDomains.vue": [
		"72ed",
		"chunk-3319c50a"
	],
	"./AnonAddy.vue": [
		"a492",
		"chunk-0776a84f"
	],
	"./Apod.vue": [
		"64ab",
		"chunk-5af9d32c"
	],
	"./BlacklistCheck.vue": [
		"b5ef",
		"chunk-74dae782"
	],
	"./Blank.vue": [
		"c16a",
		"chunk-10c67d3f"
	],
	"./Clock.vue": [
		"5e2a",
		"chunk-77ac20c5"
	],
	"./CodeStats.vue": [
		"d7a5",
		"chunk-50f31ec3",
		"chunk-978ecafa"
	],
	"./CovidStats.vue": [
		"714f",
		"chunk-50f31ec3",
		"chunk-504b2912"
	],
	"./CryptoPriceChart.vue": [
		"679e",
		"chunk-50f31ec3",
		"chunk-1831ea42"
	],
	"./CryptoWatchList.vue": [
		"c772",
		"chunk-1293d0ac"
	],
	"./CveVulnerabilities.vue": [
		"c632",
		"chunk-5a83a8d0"
	],
	"./DomainMonitor.vue": [
		"3bae",
		"chunk-5653a48e"
	],
	"./EmbedWidget.vue": [
		"ec79",
		"chunk-760cbff6"
	],
	"./EthGasPrices.vue": [
		"91f0",
		"chunk-50f31ec3",
		"chunk-d3c1d796"
	],
	"./ExchangeRates.vue": [
		"a65f",
		"chunk-2b813498"
	],
	"./Flights.vue": [
		"a75b",
		"chunk-a1ffb72a"
	],
	"./GitHubProfile.vue": [
		"e160",
		"chunk-56203a73"
	],
	"./GitHubTrending.vue": [
		"3134",
		"chunk-1cff14c6"
	],
	"./GlAlerts.vue": [
		"6193",
		"chunk-9b485150"
	],
	"./GlCpuCores.vue": [
		"3237",
		"chunk-3b0a4027"
	],
	"./GlCpuGauge.vue": [
		"9304",
		"chunk-b0bfdff0"
	],
	"./GlCpuHistory.vue": [
		"0949",
		"chunk-50f31ec3",
		"chunk-65893095"
	],
	"./GlCpuTemp.vue": [
		"6134",
		"chunk-70ae1244"
	],
	"./GlDiskIo.vue": [
		"35a8",
		"chunk-56a8dfd4"
	],
	"./GlDiskSpace.vue": [
		"1f55",
		"chunk-11166be8"
	],
	"./GlIpAddress.vue": [
		"82d1",
		"chunk-60cd38ea"
	],
	"./GlLoadHistory.vue": [
		"ce80",
		"chunk-50f31ec3",
		"chunk-3dc389b2"
	],
	"./GlMemGauge.vue": [
		"2af9",
		"chunk-bbc20504"
	],
	"./GlMemHistory.vue": [
		"dccf",
		"chunk-50f31ec3",
		"chunk-77339904"
	],
	"./GlNetworkInterfaces.vue": [
		"4558",
		"chunk-3372b232"
	],
	"./GlNetworkTraffic.vue": [
		"bf13",
		"chunk-50f31ec3",
		"chunk-315cefb0"
	],
	"./GlSystemLoad.vue": [
		"7ce6",
		"chunk-50f31ec3",
		"chunk-c1798d28"
	],
	"./GluetunStatus.vue": [
		"4841",
		"chunk-3de3f990"
	],
	"./HealthChecks.vue": [
		"dac2",
		"chunk-73fa2ab6"
	],
	"./IframeWidget.vue": [
		"2386",
		"chunk-bdede572"
	],
	"./ImageWidget.vue": [
		"2356",
		"chunk-a90fd87c"
	],
	"./Jokes.vue": [
		"7b50",
		"chunk-efce9ef4"
	],
	"./MullvadStatus.vue": [
		"1e8e",
		"chunk-53208a05"
	],
	"./NdCpuHistory.vue": [
		"e641",
		"chunk-50f31ec3",
		"chunk-2913520c"
	],
	"./NdLoadHistory.vue": [
		"47ad",
		"chunk-50f31ec3",
		"chunk-11b92c83"
	],
	"./NdRamHistory.vue": [
		"1afb",
		"chunk-50f31ec3",
		"chunk-7e849af0"
	],
	"./NewsHeadlines.vue": [
		"f406",
		"chunk-15a44710"
	],
	"./NextcloudNotifications.vue": [
		"f48c",
		"chunk-48c0ff36"
	],
	"./NextcloudPhpOpcache.vue": [
		"8eac",
		"chunk-42edc75e"
	],
	"./NextcloudStats.vue": [
		"f9cc1",
		"chunk-7c924c33"
	],
	"./NextcloudSystem.vue": [
		"2f96",
		"chunk-50f31ec3",
		"chunk-3099516e"
	],
	"./NextcloudUser.vue": [
		"f298",
		"chunk-dc349be0"
	],
	"./NextcloudUserStatus.vue": [
		"2937",
		"chunk-73844b54"
	],
	"./PiHoleStats.vue": [
		"3ce5",
		"chunk-50f31ec3",
		"chunk-d41dc632"
	],
	"./PiHoleTopQueries.vue": [
		"7309",
		"chunk-4ab237aa"
	],
	"./PiHoleTraffic.vue": [
		"e61b",
		"chunk-50f31ec3",
		"chunk-2d225b78"
	],
	"./PublicHolidays.vue": [
		"79b9",
		"chunk-d6f99a60"
	],
	"./PublicIp.vue": [
		"4f0c",
		"chunk-b8c31910"
	],
	"./RssFeed.vue": [
		"4f87",
		"chunk-300c1ba6"
	],
	"./Sabnzbd.vue": [
		"2e26",
		"chunk-2d711498"
	],
	"./SportsScores.vue": [
		"7fa8",
		"chunk-3694a0c2"
	],
	"./StatPing.vue": [
		"d71a",
		"chunk-2853b834"
	],
	"./StockPriceChart.vue": [
		"b1f5",
		"chunk-50f31ec3",
		"chunk-3e78e074"
	],
	"./SynologyDownload.vue": [
		"5a4b",
		"chunk-1f7f5e00"
	],
	"./SystemInfo.vue": [
		"0021",
		"chunk-50f31ec3",
		"chunk-4d8f8688"
	],
	"./TflStatus.vue": [
		"5d62",
		"chunk-4a2fb285"
	],
	"./WalletBalance.vue": [
		"6d7b",
		"chunk-f05e29f4"
	],
	"./Weather.vue": [
		"048f",
		"chunk-2e5aea38"
	],
	"./WeatherForecast.vue": [
		"d76f",
		"chunk-e3c90b5c"
	],
	"./WidgetBase.vue": [
		"2955"
	],
	"./XkcdComic.vue": [
		"a2e3",
		"chunk-4eac1b1e"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "50ed";
module.exports = webpackAsyncContext;